import { ReactNode } from 'react';

interface PageToolbarProps {
  children: ReactNode;
}

export function PageToolbar({ children }: PageToolbarProps) {
  return (
    <div className="px-6 py-2.5 border-b border-border bg-panel flex items-center gap-3 flex-wrap">
      {children}
    </div>
  );
}
